/**
 * Created by Sasha on 7/25/2018.
 */
import moment from 'moment';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import { AppConfig } from '../../app.config';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
@Injectable()
export class SubCreditTargetService  {
  subCreditTarget: any[];
  onSubCreditTargetChanged: BehaviorSubject<any> = new BehaviorSubject({});
  id;
  constructor (private http: HttpClient, private api: AppConfig) {

  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
  {

    return new Promise<void>((resolve, reject) => {

      Promise.all([
        this.getSubCreditTargets()
      ]).then(
        () => {
          resolve();
        },
        reject
      );
    });
  }
  getSubCreditTargets () {
    return new Promise((resolve, reject) => {
      this.http.get(this.api.baseUrl + '/subCreditTarget/subCreditTargets?id=' + this.id  , this.api.jsonTokenHeaders)
        .subscribe((response: any) => {
          this.subCreditTarget = response;
          this.onSubCreditTargetChanged.next(this.subCreditTarget);
          resolve(response);
        }, reject);
    });

  }

  getSubCreditTargetById(id) {
    return this.http.get(this.api.baseUrl + '/subCreditTarget/subCreditTarget?id=' + id , this.api.jsonTokenHeaders);
  }

  deleteSubCreditTarget(id) {
    return this.http.delete(this.api.baseUrl + '/subCreditTarget/deleteSubCreditTarget?id=' + id , this.api.jsonTokenHeaders);
  }
  addSubCreditTarget(data) {
    return this.http.post(this.api.baseUrl + '/subCreditTarget/addSubCreditTarget' , data , this.api.jsonTokenHeaders);
  }
  updateSubCreditTargetByTGSId(oldId, newId) {
    return this.http.get(this.api.baseUrl + '/subCreditTarget/updateSubCreditTargetByTGId?oldId=' + oldId + '&newId=' + newId , this.api.jsonTokenHeaders);
  }

  setId(id) {
    this.id = id;
  }
}
